import React from "react";
import {Col, Container, Row} from "react-bootstrap";
import {mygaSession} from "../../../scripts/myga-session";
import AppContentWrapper from "../AppContentWrapper/AppContentWrapper";
import MYGAStrings from "../../../Resources/Content/MYGAStrings";
import {NassauLog} from "../../../scripts/myga-utils";
import {isFinancesComplete, isKnockout, isKnockoutFinances} from "../../../scripts/validation";
import {deleteApp} from "../../../scripts/sync-manager";

class KnockoutLanding extends React.Component {

  constructor(props) {
    super(props);
    NassauLog(`PageManager.pageAppFinances.isFinancesComplete = ${isFinancesComplete()}`);
    NassauLog(`PageManager.pageAppFinances.isKnockoutFinances = ${isKnockoutFinances()}`);
    NassauLog(`PageManager.pageAppFinances.isKnockout = ${isKnockout()}`);

  }

  componentDidMount() {
    
  }
  
  clearApplication = async () => {
    // 2021.09.23.ADivelbiss - delete this app from the backend since it was a knockout
    await deleteApp();
    // Clear out the current application
    await mygaSession.setCurrentApp(null);
  };
  
  render() {
    
    return (
        <AppContentWrapper
            nextLabel={"OK"} // Explicitly set the nextLabel for this page
            onNextPressed={this.clearApplication}
            updatePage={this.props.updatePage}>
  
          <Container>
            <Row className="row">
              <Col>
                <h1 className="text-center big default">
                  We're Sorry
                </h1>
                <hr/>
                <p className="font-page-large text-center center element-bottom-10">
                  {/*We don't have a product that's right for you at this time.*/}
                  {MYGAStrings.KnockoutLanding_NoProducts}
                </p>
                <p className="font-page-regular lead text-center center element-bottom-10">
                  {MYGAStrings.KnockoutLanding_Contact}
                </p>
              </Col>
            </Row>
          </Container>
          
        </AppContentWrapper>
    );
    
  }
}

export default KnockoutLanding;